import { useMemo } from 'react';
import usePublicProfiles from './usePublicProfiles';
import { useGetMultipleAvatarQuery } from 'Auth/redux/avatarApi';
import { getAvatarColorById } from 'assets/colors';
import { type TextareaProps } from '_common/lib/components';

export const useSuggestions = (userIdList: UserId[]): TextareaProps['mentions'] => {
  const { profiles } = usePublicProfiles(userIdList);
  const { data: avatars } = useGetMultipleAvatarQuery(userIdList);

  return useMemo<TextareaProps['mentions']>(() => {
    return Object.values(profiles).map<NonNullable<TextareaProps['mentions']>[number]>(
      (profile) => {
        const color = getAvatarColorById(profile.id, profile.initials);
        return {
          id: profile.id,
          label: profile.name,
          title: profile.name,
          description: profile.name,
          avatar: {
            imageSrc: avatars?.[profile.id],
            children: profile.initials,
            ringColor: color,
            color,
          },
        };
      },
    );
  }, [profiles, avatars]);
};
